import useSWR from 'swr';
import { boardBatchResolver } from '../hooks/use-boards';

type BoardNameProps = {
  boardId: number;
  returnString?: boolean;
};

export default function BoardName({ boardId, returnString }: BoardNameProps) {
  const {
    data: board,
    isLoading,
    error,
  } = useSWR(`/board-name/${boardId}`, async () => boardBatchResolver.resolveItem(boardId), {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  if (isLoading) {
    return 'Loading';
    //return `Loading ${boardId}`;
  }

  if (error || !board) {
    return `Board ${boardId}`;
  }

  if (returnString) {
    return board?.name.toString();
  }

  return <>{board?.name}</>;
}
